import { Navigate, useParams } from 'react-router-dom';

import { useGetPorcentajeIvaServicio } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SavePorcentajeIvaRet } from '../../shared/components/savePorcentajeRetIvaServicios';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateIvaPageInterface {}

const UpdateServiciosIvaRetPage: React.FC<UpdateIvaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_porcentajeretivaservicios);

  const { id } = useParams();
  const { data, isLoading } = useGetPorcentajeIvaServicio(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_porcentaje_ret_iva_servicios) return <Navigate to="/parametrizacion/porcentajes-ret-iva-servicios" />;

  return <SavePorcentajeIvaRet titlePage="Editar Porcentaje Retencion IVA" editPorcentajeIvaServicios={data.data} />;
};

export default UpdateServiciosIvaRetPage;
